export default __webpack_public_path__ + "static/media/Brittany Sturla.b401312e.jpg";